import { useCallback } from 'react';
import { sdk } from 'sdk';
import { GiftcardRequestPayload } from 'sdk/composable-commerce/types/payloads/CartPayloads';
import { Cart } from 'shared/types/cart';

const useGivex = () => {
  const applyGiftcard = useCallback(async (data: GiftcardRequestPayload) => {
    const response = await sdk.callAction<Cart>({
      actionName: 'givex/applyGiftcard',
      payload: data,
    });

    return response;
  }, []);

  const preauthGiftcards = useCallback(async () => {
    const response = await sdk.callAction<PaymentResponse>({
      actionName: 'givex/preauthGiftcards',
    });
    if (response.isError) {
      throw new Error('Gift Card preauthorization failed');
    }
    return response.data as PaymentResponse;
  }, []);

  const cancelPreauthGiftcards = useCallback(async () => {
    await sdk.callAction<void>({
      actionName: 'givex/cancelPreauthGiftcards',
    });
  }, []);

  const placeOrder = useCallback(async () => {
    const response = await sdk.callAction<PaymentResponse>({
      actionName: 'givex/placeOrder',
    });

    if (response.isError) {
      let errorMessage = response.error?.message;
      if (errorMessage?.indexOf('Error: ') !== -1) {
        errorMessage = errorMessage.substring(7);
      }
      throw new Error(errorMessage);
    }

    return (response.isError ? {} : response.data) as PlaceGiftcardOrderResponse;
  }, []);

  return { applyGiftcard, preauthGiftcards, cancelPreauthGiftcards, placeOrder };
};

export interface PlaceGiftcardOrderResponse {
  orderNumber: string;
}

export default useGivex;
